export default "/assets/images/bbq-video.65ff5af8d9f14f13.mp4";